import type { ReactNode } from 'react';
import { useContext } from 'react';

import { TextButton } from '@procurify/ui'
import { useIntl } from 'react-intl'

import messages from './messages'
import { StatusCardLegacyCollapsibleToggleStyled } from './styles/StatusCardLegacyCollapsibleToggleStyled'
import { StatusCardLegacyContext } from '../../StatusCardLegacyContext'

export interface IStatusCardLegacyCollapsibleToggleProps {
  renderLabel?: (showCollapsible: boolean, label: string) => ReactNode
  label?: string
}

const defaultRenderLabel: IStatusCardLegacyCollapsibleToggleProps['renderLabel'] =
  (showCollapsible, label = '') => {
    const intl = useIntl()
    return (
      <TextButton>
        {`${showCollapsible ? '-' : '+'} ${
          showCollapsible
            ? intl.formatMessage(messages.hideLabel)
            : intl.formatMessage(messages.showLabel)
        }${label ? ` ${label}` : ''}`}
      </TextButton>
    )
  }

export const StatusCardLegacyCollapsibleToggle = ({
  label,
  renderLabel = defaultRenderLabel,
}: IStatusCardLegacyCollapsibleToggleProps) => {
  const { showCollapsible, setShowCollapsible } = useContext(
    StatusCardLegacyContext
  )

  const onClick = () => {
    setShowCollapsible(!showCollapsible)
  }

  return (
    <StatusCardLegacyCollapsibleToggleStyled onClick={onClick}>
      {renderLabel(showCollapsible, label)}
    </StatusCardLegacyCollapsibleToggleStyled>
  )
}

StatusCardLegacyCollapsibleToggle.displayName =
  'StatusCardLegacyCollapsibleToggle'
